import React from 'react';

type QuestionProps = {
    size?: number;
    circleColor?: string;
    textColor?: string;
};

export const Question: React.FC<QuestionProps> = ({
    size = 32,
    circleColor = '#191F2E',
    textColor = '#191F2E',
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            fill={circleColor}
        />
        <path
            d="M10.5102 11.5723C10.495 11.8447 10.7198 12.0654 10.9927 12.0654H12.6416C12.9178 12.0654 13.1374 11.8403 13.1745 11.5666C13.3524 10.2544 14.253 9.29785 15.8584 9.29785C17.2295 9.29785 18.4864 9.9834 18.4864 11.6338C18.4864 12.9033 17.7373 13.4873 16.5567 14.376C15.211 15.3535 14.1446 16.4961 14.2207 18.3496L14.2267 18.7832C14.2304 19.0567 14.4532 19.2764 14.7266 19.2764H16.3487C16.6248 19.2764 16.8487 19.0525 16.8487 18.7764V18.5654C16.8487 17.1309 17.3946 16.7119 18.8672 15.5947C20.086 14.668 21.3555 13.6396 21.3555 11.4814C21.3555 8.45996 18.8038 7 16.0108 7C13.4766 7 10.6993 8.18122 10.5102 11.5723ZM13.6241 23.0977C13.6241 24.1641 14.4746 24.9512 15.6426 24.9512C16.8614 24.9512 17.6993 24.1641 17.6993 23.0977C17.6993 21.9932 16.8614 21.2188 15.6426 21.2188C14.4746 21.2188 13.6241 21.9932 13.6241 23.0977Z"
            fill={textColor}
        />
    </svg>
);

export default Question;
